import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import logo from "../images/logo_black.png";

import Footer from "./components/Footer";
import Loading from "./components/Loading";

import "../css/style.css";

const Step10_Shipping = () => {
    const [user, setUser] = useState({
        salutation: "",
        firstname: "",
        lastname: "",
        company: "",
        function: "",
        street: "",
        place: "",
        city: "",
        country: "176",
        phone: "",
        email: "",
        howHaveYouHeard: "",
        exhibitor: "Aussteller: false",
        logoPresence: "Ausstellerfläche / Logopräsenz: false",
        investment: "Investieren: false",
        cityTour: "Privaten Kunsthaus Führung: false",
        vrMandate: "",
        swissVRAwards: "",
        usesThirdPartyFinancialProducts: "",
        responsibleForDrittprodukteSelektion: "",
        activeContributionDrittprodukte: "",
        agreement: false,
        cancelationTerms: false,
        isCustomCheckboxChecked: false,
        optionsYesOrNoAnswers: {} // Store answers for OptionsYesOrNo
    });

    const theEvent = JSON.parse(sessionStorage.getItem("FUWEvent"));
    const remarks = JSON.parse(theEvent.remarks);
    const howHaveYouHeard = remarks["ListItemsHowHaveYouHeard"];
    const [orderId] = useState(sessionStorage.getItem("OrderId"));
    const [selectedEventIds, setSelectedEventIds] = useState([]);
    const [isSwappingTickets, setIsSwappingTickets] = useState(false);
    const isSubmittingRef = useRef(false);

    const toggleEventOption = (eventId) => {
        setSelectedEventIds((prev) =>
            prev.includes(eventId) ? prev.filter((id) => id !== eventId) : [...prev, eventId]
        );
    };

    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState(""); //Todo how can i handle these errors
    const [countries, setCountries] = useState([]);
    const [resources, setResources] = useState({});
    const [token] = useState(sessionStorage.getItem("token"));

    // fetching resources
    const { language } = useParams();

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        requestResources();
        requestCountries();

    }, [language]);

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.log(error.response.data));
    };

    const requestCountries = () => {
        setLoading(true);

        axios
            .get(`${baseUrl}/Countries?languageCode=${language}`)
            .then((res) => {
                let countries = res.data;

                //first add switzerland, germany and austria
                const indexCH = countries.findIndex((c) => c.id === 176);
                const ch = countries[indexCH];
                countries.splice(indexCH, 1);

                var indexDE = res.data.findIndex((c) => c.id === 229);
                const de = countries[indexDE];
                countries.splice(indexDE, 1);

                var indexAU = res.data.findIndex((c) => c.id === 228);
                const au = countries[indexAU];
                countries.splice(indexAU, 1);

                countries.unshift({ id: "", name: "---------" });
                countries.unshift(au);
                countries.unshift(de);
                countries.unshift(ch);

                setCountries(res.data);
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/sessiontimeout`);
            });

        setTimeout(() => setLoading(false), 500);
    };

    const onOptionsChange = (e) => {

        if (e.target.value.includes("Ausstellerfläche / Logopräsenz") || e.target.value.includes("logo presence")) {
            setUser({ ...user, ["logoPresence"]: "Ausstellerfläche / Logopräsenz: " + e.target.checked });
        }

        if (e.target.value.includes("Investieren") || e.target.value.includes("Invest in your knowledge")) {
            setUser({ ...user, ["investment"]: "Investieren: " + e.target.checked });
        }

        if (e.target.value.includes("Aussteller ")) {
            setUser({ ...user, ["exhibitor"]: "Aussteller: " + e.target.checked });
        }

        if (e.target.value.includes("Privaten Kunsthaus Führung")) {
            setUser({ ...user, ["cityTour"]: "Privaten Kunsthaus Führung: " + e.target.checked });
        }

        if (e.target.value.includes("agreement")) {
            setUser({ ...user, ["agreement"]: e.target.checked });
        }

        if (e.target.value.includes("cancelationTerms")) {
            setUser({ ...user, ["cancelationTerms"]: e.target.checked });
        }

        if (e.target.value.includes("Swiss VR-Awards")) {
            setUser({ ...user, ["swissVRAwards"]: "Teilnahme an den Swiss VR-Awards: " + e.target.checked });
        }
    }

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const onRadioYesOrNoChange = (option, value) => {
        // Prepare formatted string
        const formatted = `${option}: ${value}`;
        // Prepare new user object
        let newUser = {
            ...user,
            optionsYesOrNoAnswers: {
                ...user.optionsYesOrNoAnswers,
                [option]: value
            }
        };
        // Set corresponding user property if question matches
        if (option.includes("Teil Ihres Business-Modells")) {
            newUser.usesThirdPartyFinancialProducts = formatted;
        }
        if (option.includes("verantwortlich für die Selektion dieser Drittprodukte")) {
            newUser.responsibleForDrittprodukteSelektion = formatted;
        }
        if (option.includes("Auswahl dieser Drittprodukte aktiv bei")) {
            newUser.activeContributionDrittprodukte = formatted;
        }
        if (option.includes("Möchten Sie an der Award Night teilnehmen")) {
            newUser.awardNightParticipation = formatted;
        }
        setUser(newUser);
    };

    const mapCheckboxOptions = () => {

        let options = remarks["Options"];

        return (
            options.map(
                (opt, index) => (
                    <div key={index} className="row mt-4">
                        <div className="col-md-12">
                            <div class="form-check">
                                <input className="form-check-input" id={"chkOption" + index} type="checkbox" value={opt} onChange={(e) => onOptionsChange(e)} />
                                <label className="form-check-label" htmlFor={"chkOption" + index}>{opt}</label>
                            </div>
                        </div>
                    </div>
                )
            )
        );
    }

    const mapEventOptions = () => {
        const eventOptions = remarks["EventOptions"];
        if (!eventOptions || !Array.isArray(eventOptions) || eventOptions.length === 0) return null;

        return (
            <>
                <div className="row mt-4">
                    <div className="col-md-12">
                        <span>
                            <b>{remarks["EventOptionsLeadText"]}</b>
                        </span>
                    </div>
                </div>
                {eventOptions.map((opt, index) => (
                    <div className="row mt-2" key={opt.EventId}>
                        <div className="col-md-12 pt-2 pb-2">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkboxEventOption_${index}`}
                                    value={opt.EventId}
                                    checked={selectedEventIds.includes(opt.EventId)}
                                    onChange={() => toggleEventOption(opt.EventId)}
                                />
                                <label className="form-check-label eventOptionLabel" htmlFor={`checkboxEventOption_${index}`}>
                                    {opt.Title && <div className="mb-2"><b>{opt.Title}</b></div>}
                                    {opt.Speakers && opt.Speakers.length > 0 &&
                                        opt.Speakers.map((spk, i2) => (
                                            <div key={i2}><small><b>{spk.Name}</b> {spk.Company}</small></div>
                                        ))}
                                </label>
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );
    };

    const mapRadioOptionsYesOrNo = () => {
        const options = remarks["OptionsYesOrNo"];
        if (!options || !Array.isArray(options)) return null;
        return options.map((opt, index) => (
            <React.Fragment key={index}>
                <div className="row mt-4">
                    <div className="col-md-12">
                        <label className="form-label mb-2">{opt}</label>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-12">
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={`radioOptionYesOrNo_${index}`}
                                id={`radioOptionYes_${index}`}
                                value="Ja"
                                checked={user.optionsYesOrNoAnswers[opt] === "Ja"}
                                onChange={() => onRadioYesOrNoChange(opt, "Ja")}
                                required
                            />
                            <label className="form-check-label" htmlFor={`radioOptionYes_${index}`}>Ja</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={`radioOptionYesOrNo_${index}`}
                                id={`radioOptionNo_${index}`}
                                value="Nein"
                                checked={user.optionsYesOrNoAnswers[opt] === "Nein"}
                                onChange={() => onRadioYesOrNoChange(opt, "Nein")}
                                required
                            />
                            <label className="form-check-label" htmlFor={`radioOptionNo_${index}`}>Nein</label>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        ));
    }

    // validating input fields
    let validation =
        /^([a-z A-Zöéàäèü]{1,70})$/.test(user.salutation) &&
        /^.{1,70}$/.test(user.firstname) &&
        /^.{1,70}$/.test(user.lastname) &&
        /^.{1,70}$/.test(user.function) &&
        /^.{1,70}$/.test(user.company) &&
        /^.{1,70}$/.test(user.street) &&
        /^.{1,70}$/.test(user.place) &&
        /^.{1,70}$/.test(user.city) &&
        /^([a-z A-Zöéàäèü 0-9 - ]{1,70})$/.test(user.country) &&
        /^.{1,70}$/.test(user.phone) &&
        /^\S+@\S+\.\S+$/.test(user.email);

    if (validation && (remarks["HasAgreement"])) {
        validation = user.agreement;
    }

    if (validation && (remarks["HasCancelationTerms"])) {
        validation = user.cancelationTerms;
    }

    // Add mandatory validation for OptionsYesOrNo
    if (remarks["OptionsYesOrNo"] && Array.isArray(remarks["OptionsYesOrNo"])) {
        validation = validation && remarks["OptionsYesOrNo"].every(opt => user.optionsYesOrNoAnswers[opt] === "Ja" || user.optionsYesOrNoAnswers[opt] === "Nein");
    }

    // Require at least one Durchführung/event selection when the ticket type is offered across multiple events
    if (remarks["EventOptions"] && Array.isArray(remarks["EventOptions"]) && remarks["EventOptions"].length > 0) {
        validation = validation && selectedEventIds.length > 0;
    }

    // Each of the events listed in remarks["EventOptions"] offers the same single ticket type,
    // only the date differs. The actual ticket type(s) to book are only known once the visitor
    // picks Durchführung(en) here, so we reconcile whatever is currently in the basket to exactly
    // match the current selection - one ticket per selected event, per originally chosen quantity.
    //
    // The per-event quantity is exactly what was added on the Home page (set there in
    // FUWOriginalTicketQuantity) - read-only here, so re-running this (double clicks, browser
    // back/forward, changing the selection and submitting again) always reconciles to the same
    // target instead of compounding or drifting from a stale/guessed value.
    const swapTicketsForSelectedEvents = async () => {
        if (!remarks["EventOptions"] || !Array.isArray(remarks["EventOptions"]) || remarks["EventOptions"].length === 0) return;
        if (selectedEventIds.length === 0) return;

        const orderRes = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
        const currentTickets = orderRes.data.tickets || [];

        const quantityPerEvent = parseInt(sessionStorage.getItem("FUWOriginalTicketQuantity"), 10) || currentTickets.length;

        if (!quantityPerEvent) return;

        const newTicketTypeIds = await Promise.all(
            selectedEventIds.map(async (eventId) => {
                const res = await axios.get(`${baseUrl}/Event/${eventId}/TicketTypes`);
                return res.data.ticketTypes[0].id;
            })
        );

        const desiredCounts = {};
        newTicketTypeIds.forEach((id) => {
            desiredCounts[id] = (desiredCounts[id] || 0) + quantityPerEvent;
        });

        const currentCounts = {};
        currentTickets.forEach((t) => {
            currentCounts[t.ticketTypeId] = (currentCounts[t.ticketTypeId] || 0) + 1;
        });

        const alreadyMatches =
            Object.keys(desiredCounts).length === Object.keys(currentCounts).length &&
            Object.entries(desiredCounts).every(([id, qty]) => currentCounts[id] === qty);

        if (alreadyMatches) return;

        if (currentTickets.length > 0) {
            await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                data: { ticketsToRemove: currentTickets.map((t) => t.id) },
            });
        }

        await axios.post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
            ticketsToAdd: Object.entries(desiredCounts).map(([ticketTypeId, quantity]) => ({
                ticketTypeId: Number(ticketTypeId),
                quantity,
            })),
        });
    };

    const addAddressToBasket = async () => {
        if (isSubmittingRef.current) return;
        isSubmittingRef.current = true;
        setIsSwappingTickets(true);

        try {
            await swapTicketsForSelectedEvents();
        } catch (error) {
            console.error(error.response?.data ?? error);
            setErrors(error.response?.data);
            setIsSwappingTickets(false);
            isSubmittingRef.current = false;
            return;
        }

        let addressBody = {
            salutation: user.salutation,
            firstname: user.firstname,
            name: user.lastname,
            company: user.company,
            street: user.street,
            function: user.function,
            postCode: user.place,
            city: user.city,
            telephone: user.phone,
            countryId: user.country,
            email: user.email,
            code1: user.investment,
            code2: user.exhibitor,
            code3: user.logoPresence,
            code4: user.vrMandate,
            code5: user.howHaveYouHeard,
            code6: user.cityTour,
            code7: "Homepage checkbox: " + sessionStorage.getItem("isCustomCheckboxChecked"),
            code8: user.swissVRAwards,
            code9: user.usesThirdPartyFinancialProducts,
            code10: user.responsibleForDrittprodukteSelektion,
            code11: user.activeContributionDrittprodukte,
            code12: user.awardNightParticipation
        };

        axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then((res) => {
                sessionStorage.setItem("FUWOrderAddress", JSON.stringify(addressBody));
                navigate(`/${language}/participants`);
            })
            .catch((error) => {
                setErrors(error.response.data);
                setIsSwappingTickets(false);
                isSubmittingRef.current = false;
            });
    };

    return (
        <div>
            {loading ? (
                <>
                    <div className="d-none d-lg-block">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="50%"
                            left="50%"
                        />
                    </div>
                    <div className="d-lg-none">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="45%"
                            left="45%"
                        />
                    </div>
                </>
            ) : (
                <>
                    {resources.translation && (
                        <div className="container pt-0 wrapper">
                            <div className="row mt-2">
                                <div className="col-md-4 text-center">
                                    <img src={logo} className="img-fluid" alt="FUW Logo"></img>
                                </div>
                            </div>
                            <div className="row mt-5 text-center">
                                <div className={"col-md-4"}>
                                    <p className="navFUWActive">{resources.translation._Buyer}</p>
                                </div>
                                <div className={"col-md-4"}>
                                    <p className="navFUW">{resources.translation._Tickets}</p>
                                </div>
                                <div className={"col-md-4"}>
                                    <p className="navFUW">{remarks["PageTitle"]}</p>
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-12 text-center">
                                    <h2 className="text-uppercase underline50">{resources.translation._Buyer}</h2>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-12 mb-4 text-center">
                                    <span className="description">
                                        {resources.translation.ShippingPleaseFill}
                                    </span>
                                </div>
                            </div>

                            {/* user data */}

                            <div className="row">
                                <div className="col-md-12">
                                    <select
                                        className="form-control inputUserInfo"
                                        aria-label={resources.translation.ShippingSalutation}
                                        name="salutation"
                                        value={user.salutation}
                                        onChange={(e) => onInputChange(e)}
                                        required>
                                        <option>{resources.translation.ShippingSalutation + "*"}</option>
                                        <option value={resources.translation._Mr}>{resources.translation._Mr}</option>
                                        <option value={resources.translation._Mrs}>{resources.translation._Mrs}</option>
                                        {resources.translation._Ms && resources.translation._Ms != "" &&
                                            <option value={resources.translation._Ms}>{resources.translation._Ms}</option>
                                        }
                                    </select>

                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="firstname"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingFirstName + "*"}
                                        value={user.firstname}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="lastname"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingLastName + "*"}
                                        value={user.lastname}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="function"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingFunction + "*"}
                                        value={user.function}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="vrMandate"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingVrMandate}
                                        value={user.vrMandate}
                                        onChange={(e) => onInputChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="company"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingCompany + "*"}
                                        value={user.company}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="street"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingStreet + "*"}
                                        value={user.street}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="place"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingPlace + "*"}
                                        value={user.place}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingCity + "*"}
                                        value={user.city}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <select
                                        className="form-control inputUserInfo"
                                        aria-label="Land"
                                        name="country"
                                        value={user.country}
                                        onChange={(e) => onInputChange(e)}>
                                        {countries.map((c, index) => (
                                            <option value={c.id} key={index}>
                                                {c.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="phone"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingPhone + "*"}
                                        value={user.phone}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control inputUserInfo"
                                        placeholder={resources.translation.ShippingEmail + "*"}
                                        value={user.email}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 pe-md-0 mt-4">
                                    <label className="form-control inputUserInfo">
                                        {resources.translation.ShippingWhereDidYouHear}
                                    </label>
                                </div>
                                <div className="col-md-8 ps-md-0 mt-4">
                                    <select
                                        className="form-control inputUserInfo"
                                        aria-label="Where did you hear"
                                        name="howHaveYouHeard"
                                        value={user.howHaveYouHeard}
                                        onChange={(e) => onInputChange(e)}>
                                        <option>{"-- " + resources.translation._PleaseChoose + " --"}</option>
                                        {howHaveYouHeard.map((h, index) => (
                                            <option value={h} key={index}>
                                                {h}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* event/Durchführung selection */}

                            {mapEventOptions()}

                            {/* checkbox options */}

                            {mapCheckboxOptions()}

                            {/* radio options Yes/No */}

                            {mapRadioOptionsYesOrNo()}

                            {/* next button */}

                            <div className={"row mt-5"}>
                                <div className="offset-md-10 col-md-2 text-end">
                                    <button className="btn form-control btnDarkblue" onClick={addAddressToBasket} disabled={!validation || isSwappingTickets}>
                                        {resources.translation._Next}
                                    </button>
                                </div>
                            </div>

                            {/* agb - cancelation terms */}

                            <div className="container mb-5">

                                {remarks["HasAgreement"] && (
                                    <div className="float-end position-relative mt-4">
                                        <div className="col-md-12 float-end">
                                            <label htmlFor="chkAgreement" className="me-3 lblAgreement" dangerouslySetInnerHTML={{ __html: resources.translation.ShippingAgreement.replace("{@pdfUrl}", remarks["AgreementPDF"]) }}></label>
                                            <input id="chkAgreement" type="checkbox" className="checkboxAgreement form-check-input" value="agreement" onChange={(e) => onOptionsChange(e)} />
                                        </div>
                                    </div>
                                )}

                                {remarks["HasCancelationTerms"] && (
                                    <div className="float-end position-relative mt-4">
                                        <div className="col-md-12 float-end">
                                            <label htmlFor="chkCancelationTerms" className="me-3 lblAgreement">{remarks["CancelationTermsText"]}</label>
                                            <input id="chkCancelationTerms" type="checkbox" className="checkboxAgreement form-check-input" value="cancelationTerms" onChange={(e) => onOptionsChange(e)} />
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}
                    <div className="container wrapper">
                        <div className="col-md-12 pt-4 text-center">
                            <Footer language={language} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Step10_Shipping;